/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputSignalIntegrationLogItem
 */
export interface OutputSignalIntegrationLogItem {
    /**
     * 
     * @type {string}
     * @memberof OutputSignalIntegrationLogItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSignalIntegrationLogItem
     */
    groupName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSignalIntegrationLogItem
     */
    status?: string;
}

/**
 * Check if a given object implements the OutputSignalIntegrationLogItem interface.
 */
export function instanceOfOutputSignalIntegrationLogItem(value: object): boolean {
    return true;
}

export function OutputSignalIntegrationLogItemFromJSON(json: any): OutputSignalIntegrationLogItem {
    return OutputSignalIntegrationLogItemFromJSONTyped(json, false);
}

export function OutputSignalIntegrationLogItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputSignalIntegrationLogItem {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function OutputSignalIntegrationLogItemToJSON(value?: OutputSignalIntegrationLogItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': value['createdAt'],
        'groupName': value['groupName'],
        'status': value['status'],
    };
}

